var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _use, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolycomLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 800,
    width: 1200,
    viewBox: "-22.67715 -9.7653 196.5353 58.5918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(16.79609 -20.01675 -19.79294 -16.86013 4.8484 27.0767)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1227,
    stopColor: "#94a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5294,
    stopColor: "#94a9bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(32.12336 -32.12336) rotate(-6 -4.1679 -2.7297)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d11c23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    stopColor: "#d11c23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a91317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.10753 -6.0869 -6.01885 -5.12698 16.3078 30.427)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1227,
    stopColor: "#94a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5294,
    stopColor: "#94a9bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-12.14992 12.14992) rotate(-71 .925 1.7976)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5725,
    stopColor: "#94a9bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.29826 -6.31423 -6.24367 -5.31848 11.2253 9.9695)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1227,
    stopColor: "#94a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5294,
    stopColor: "#94a9bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-29.74812 29.74812) rotate(-71 .4571 1.2746)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94a9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5725,
    stopColor: "#94a9bb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 4.1072c-6.068.023-11.491 4.134-12.807 10.173-.195.898-.29 1.794-.293 2.678v.067c.014 5.995 4.293 11.421 10.534 12.781 7.184 1.565 14.246-2.847 15.774-9.856.194-.892.289-1.782.293-2.659v-.123c-.031-5.984-4.307-11.388-10.535-12.746-.964-.21-1.925-.313-2.873-.315zm-1.085 24.233c-5.309-1.156-8.624-6.628-7.405-12.22 1.219-5.595 6.51-9.19 11.818-8.033 5.306 1.157 8.622 6.629 7.403 12.221-1.065 4.886-5.24 8.249-9.816 8.249-.662 0-1.33-.071-2-.217",
    opacity: 0.6,
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4065 0A16.0595 16.155 0 008.3479 16.1543a16.0595 16.155 0 0016.0586 16.1543A16.0595 16.155 0 0040.465 16.1543 16.0595 16.155 0 0024.4065 0zm1.2968 2.8145A12.722 11.6445 0 0138.424 14.459a12.722 11.6445 0 01-12.7207 11.6445A12.722 11.6445 0 0112.9807 14.459 12.722 11.6445 0 0125.7033 2.8145",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.204 25.3492c-1.842 1.983-4.39 3.18-7.091 3.209.582.482 1.19.929 1.834 1.325 2.815-.525 5.372-1.943 7.27-4.008-.695-.12-1.368-.3-2.013-.527",
    opacity: 0.6,
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.168 12.4732c-2.115 1.668-3.686 3.898-4.592 6.39.433 2.575 1.47 4.94 2.958 6.948.013.019.027.037.041.054-.77-3.041-.074-6.228 1.732-8.794-.027-.107-.055-.217-.079-.322a10.808 10.808 0 01-.247-2.295c0-.677.064-1.337.188-1.981v-.01",
    opacity: 0.98,
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.697 4.1202c-1.506 1.355-2.759 2.995-3.666 4.832 1.571-.814 3.35-1.202 5.166-1.05.81-1.093 1.824-2.05 2.984-2.834-.671-.266-1.381-.483-2.113-.645-.779-.167-1.558-.269-2.328-.303",
    opacity: 0.6,
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.987 9.3992c-1.773 0-3.569.332-5.307 1.032-1.294.52-2.47 1.211-3.511 2.041v.01c-.124.644-.188 1.308-.188 1.981 0 .788.086 1.553.247 2.294.024.106.052.217.079.323 1.285-1.834 3.142-3.349 5.428-4.271 5.952-2.396 12.583.148 14.816 5.69.604 1.492.826 3.054.71 4.579-.253 3.299-2.068 6.446-4.994 8.474-.746.52-1.567.968-2.446 1.321-5.954 2.397-12.588-.151-14.818-5.689a9.9933 9.9933 0 01-.428-1.309c-.014-.018-.028-.036-.041-.055a16.1357 16.1357 0 01-2.958-6.949c-1.221 3.351-1.249 7.179.202 10.787 2.332 5.793 7.816 9.346 13.577 9.403h.268c1.73-.016 3.48-.348 5.174-1.031 4.932-1.986 8.147-6.437 8.861-11.431.271-1.884.184-3.848-.301-5.782a15.619 15.619 0 00-.653-2.009c-2.354-5.839-7.906-9.404-13.717-9.404",
    opacity: 0.98,
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6711 15.9876l-4.648 11.882-4.65-11.882h-2.642l5.557 13.228.216.503.308.748c-.28.945-.741 1.48-.784 1.526-.035.032-.059.055-.083.099 0 0-.007.01-.007.011-.403.51-.845.837-1.272.964-.288.088-.588.101-.912.018-.377-.098-.787-.318-1.218-.655l-1.339 1.731c1.093.861 2.102 1.147 2.92 1.169.45.013.858-.065 1.184-.165.935-.284 1.775-.925 2.489-1.887a.741.741 0 00.106-.136c.076-.102.156-.215.229-.337.059-.088.116-.177.171-.284.071-.139.151-.266.209-.41.03-.041.052-.086.077-.142.018-.055.056-.127.087-.19l.098-.269.419-.964 6.126-14.558m-47.2572-3.1338h5.416c1.669 0 3.484 1.582 3.484 3.633 0 2.077-1.815 3.63-3.484 3.6l-5.9199.03v2.224h5.9199c3.25 0 6.12-2.372 6.12-5.854 0-3.545-2.928-5.887-6.12-5.887h-7.963v19.53h2.547"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M69.3044 17.5389c-2.899 0-4.743 2.46-4.743 5.504 0 3.046 1.844 5.534 4.743 5.534 2.927 0 4.743-2.459 4.743-5.534 0-3.044-1.816-5.504-4.743-5.504m0 12.971c-4.158 0-7.173-3.337-7.173-7.467 0-4.097 3.015-7.464 7.173-7.464 4.186 0 7.172 3.367 7.172 7.464 0 4.13-2.986 7.467-7.172 7.467"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7785 30.1297l-.029-19.53h2.342l.03 19.53m23.1379.4805c-4.157 0-7.173-3.338-7.173-7.467 0-4.098 3.016-7.465 7.173-7.465 1.758 0 3.484.293 5.562 2.43l-1.551 1.521c-1.317-1.463-2.488-1.99-4.011-1.99-2.898 0-4.743 2.459-4.743 5.504 0 3.046 1.845 5.535 4.743 5.535 1.523 0 2.694-.557 4.011-2.05l1.551 1.551c-2.078 2.11-3.804 2.431-5.562 2.431"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#g",
    transform: "translate(48.643)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.2384 30.1297v-9.223c0-2.285-.935-3.368-2.693-3.368-1.493 0-2.634 1.172-3.395 2.108v10.483h-2.344v-9.223c0-2.285-.965-3.368-2.693-3.368-1.522 0-2.635 1.172-3.425 2.108v10.483h-2.344v-14.142h2.344v1.757c.643-.791 1.815-2.167 4.099-2.167 2.049 0 3.366.936 3.953 2.664.848-1.2 2.195-2.664 4.508-2.664 2.869 0 4.334 1.93 4.334 5.329v9.223m2.4486-13.5595v1.77h-.27v-2.01h.82c.34 0 .64.24.64.61 0 .45-.39.59-.51.59l.54.81h-.34l-.52-.8h-.44v-.24h.63c.17 0 .36-.15.36-.36 0-.22-.19-.37-.36-.37zm-1.1.76c0 .82.67 1.5 1.5 1.5s1.49-.68 1.49-1.5c0-.84-.66-1.5-1.49-1.5s-1.5.66-1.5 1.5zm-.25 0c0-.98.78-1.75 1.75-1.75s1.75.77 1.75 1.75c0 .96-.78 1.75-1.75 1.75s-1.75-.79-1.75-1.75"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolycomLogo);
export default __webpack_public_path__ + "static/media/Polycom-logo.ae81cf9c99e9d1f7f7ab5309dcc2b859.svg";
export { ForwardRef as ReactComponent };